import { Uuid } from './id';
import { TtsLocale } from './locale';

export enum GameImageType {
  Image = 'image',
  Resource = 'resource',
}

export interface GameImage<T = GameImageType> {
  type: T;
  fileId: Uuid;
}

export enum GameSoundType {
  Tts = 'tts',
  Audio = 'audio',
}

interface Audio {
  type: GameSoundType.Audio;
  fileId: Uuid;
  speed?: number;
  volume?: number;
}

interface Tts {
  type: GameSoundType.Tts;
  text: string;
  locale: TtsLocale;
  fileId?: Uuid;
  speed?: number;
  volume?: number;
}

export type GameSound = Audio | Tts;

export type GameCharacter<B extends boolean> = {
  character: string;
  ttsAudio?: Uuid;
} & (B extends true ? { fileId: Uuid } : { fileId?: Uuid });

export interface GameAssets {
  images: Uuid[];
  audios: Uuid[];
  videos: Uuid[];
  resourceImages: Uuid[];
  strokes: Uuid[];
  ttsAudios: Uuid[];
}

export interface Transcriptions {
  pinyin?: string;
  romaji?: string;
  hiragana?: string[][];
}
